import { createService } from '../../api/createService';
import { TokensSchema } from './TokensService.schemas';

export default createService(
  {
    getTokens: {
      method: 'GET',
      url: '/tokenbalance',
      responseSchema: TokensSchema,
    },
  },
  ({ userId }) => `/Players/${userId}`,
);
